export interface Simulator {
    id?: number,
    user?: Utente,
    filters: FilterData
    createdAt?: string
}

export interface FilterData {
    numberOfPositions: number,
    exemptionCodes: string[],
    years: number[],
    type: TypeE
    minAmount: number,
    maxAmount: number,
    checked: boolean,
    exemptionCodeChecked: boolean
}

export interface Utente {
    id: number,
    email: string,
    password: string,
    nome: string,
    cognome: string,
    ruolo: Ruolo
}

export interface Ruolo {
    id: number,
    nome: string,
    descrizione: string
}

export interface Exemption {
    code: string
}

export interface FileTs {
    id: number,
    year: number,
    date: string,
    protocol: string,
    exemptionCode: string,
    person: Person,
    processedFile: ProcessedFile,
    totalSpecialist: number,
    totalPharmaceutical: number,
    totalTicket: number,
    status: Status,
    numberOfInstallment: number,
    totalInterest: number,
    type: TypeE,
    totalSanction: number,
    firstInstallmentPaid?: boolean,
}

export interface Person {
    id: number,
    lastName: string,
    firstName: string,
    dateOfBirth: string,
    placeOfBirth: string,
    fiscalCode: string,
    residenceAddress: string,
    residenceHouseNumber: string,
    residenceCity: string,
    residencePostalCode: string,
    residenceProvince: string
    contact: ContactProfileDTO
    active:boolean,

    domicileAt: string,
    domicileAddress: string,
    domicileHouseNumber: string,
    domicilePostalCode: string,
    domicileCity: string,
    domicileProvince: string
}

export interface ContactProfileDTO {
    id: number,
    name: string,
    email: string,
    phone: string
}

export interface ProcessedFile {
    id: number,
    fileName: string,
    processedAt: string,
    hash: string,
    processedBy: Utente
}

export interface Status {
    id: number,
    code: StatusCodeE,
    description: string,
    ordine: number
}

export interface Installment {
    id: number,
    order: number,
    simulator: Simulator,
    person: Person,
    total: number,
    totalSpese: number,
    totalSanzione: number,
    deadline: string,
    installmentRate: number,
    status: InstallmentStatus,
    dateOfPayment: string,
    uniquePayment: boolean,
    version: number,
    paymentType?: PaymentType | null;
    avalle: boolean,
    manualPayment:boolean
}

export interface InstallmentStatus {
    id: number,
    code: string,
    description: string
}

export interface Payment {
    id: number,
    installment: Installment,
    iuv: string,
    iud: string,
    file: string
}

export interface SimulatoreFileTs {
    id: SimulatoreFileTsId,
    simulator: Simulator,
    fileTs: FileTs
}

export interface SimulatoreFileTsId {
    simulatoreId: number,
    fileTsId: number
}

export interface FileTSStatusStatistic {
    codStatus: StatusCodeE,
    count: number
}

export interface SimulatedFileTS {
    index?:number,
    simulatorId: number,
    personId: number,
    fullName: string,
    fiscalCode: string,
    years: string[],
    exemptionCodes: string[],
    hasInstallment: boolean,
    hasPayment: boolean,
    totalTicket: number,
    type: TypeE,
    totalInterest: number,
    totalSanction: number,
    totalSpese: number,
    totalSum: number,
    status: StatusCodeE,
    protocolNumbers: string[],
    motivazione?: string;
    protocolDate: string;
    sendStatus?: string;
    deadline?: string;
}

export enum PaymentType {
    PAGOPA = "PAGOPA",
    BONIFICO_BANCARIO = "BONIFICO_BANCARIO"
}

export const PAYMENT_TYPE_LABEL: Record<PaymentType, string> = {
    [PaymentType.PAGOPA]: "PagoPA",
    [PaymentType.BONIFICO_BANCARIO]: "Bonifico Bancario",
};


export interface InstallmentReportDTO {
    personId: number;
    firstName: string;
    lastName: string;
    fiscalCode: string;
    years: string;
    exemptionCodes: string;
    archiveProtocol: string;
    installmentOrder: number;
    ticketRata: number;
    expenses: number;
    penalty: number;
    interests: number;
    paymentDate: string | null;
    totalInstallmentAmount: number;
    collectedAmount: number;
    deadlineDate: string;
    daysUntilDue: number;
    installmentStatusId: number;

    totalInstallments: number;
    paidInstallmentsCount: number;

    correctedTotalInstallmentAmount: number;
    totalInstallmentSum: number;
    totalPaid: number;
    totalToBePaid: number

    allInstallmentsPaid: boolean;
    paymentType: PaymentType;
    missedPaymentApplied :boolean;
    fileType: string
}




export interface InstallmentTraceReportDTO {
    rataId: number;

    years: string;
    tipologia: "Diffida" | "Processo Verbale";
    fiscalCode: string;
    lastName: string;
    firstName: string;
    exemptionCodes: string;
    archiveProtocol: string;

    ticket: number;
    interessi: number;
    sanzione: number;
    spese: number;
    totale: number;

    variazioneSiNo: "SI" | "NO";
    rateizzazioneSiNo: "SI" | "NO";
    numRate: string;
    mancatoPagamentoUnico:boolean;

    ticketRata: number;
    interessiRata: number;
    sanzioneRata: number;
    speseRata: number;
    totaleRata: number;

    importoPagato: number;
    dataPagamento: string;

    metodoPagamento: string;
    numeroPagamento: string | null;
    causaleVersamento: string | null;
    tipoDovuto: string;

    heirFiscalCode?: string | null;
    heirLastName?: string | null;
    heirFirstName?: string | null;
    paymentType: PaymentType | null;


}





export interface StatisticsCombinator {
    simulator: Simulator
    statistics: SimulatedFileTSStatisticProjectionDto
}

export interface SimulatedFileTSStatisticProjectionDto {
    totalCosts: number,
    totalOccurrences: number,
    totalPerson: number,
    totalSum: number,
    totalTicket: number
    typeList: string[],
    totalSanction: number,
    totalInterests: number,
    fileTSStatusStatistics: FileTSStatusStatistic[]
}

export interface FileTsFilter {
    selectedCodes?: string[];
    statusCode?: StatusCodeE | null;
    amountFrom?: number;
    amountTo?: number;
    selectedYears?: number[];
    fiscalCode?: string;
    fullName?: string;
    suspensionMotivation?: string;
    fileType?: TypeE;
}

export interface ProcessedPracticeDetail {
    simulatorId: number,
    numberOfInstallments: number,
    numberOfPaidInstallments: number,
    exemptionCodes: string[],
    totalTickets: number,
    protocolNumber: string,
    createdAt: string,
    communicationDate: string,
    type: TypeE,
    status: string,
    years: number[]
    totalSanction: number,
    totalExpense: number,
    totalInterest: number,
    total: number,
    firstDocumentYear: string,
    paidUniqueInstallment: boolean
}

export interface FieldError {
    field: string;
    message: string;
}

export interface ErrorResponse {
    timestamp: Date;
    status: HttpStatus;
    errorCode: ErrorCode;
    message: string;
    userMessage: string;
    path: string;
    fieldErrors: FieldError[];
}

export interface ResponseData<T> {
    success: boolean;
    data: T;
    error: ErrorResponse;
}

//PAGINATION
export interface Page {
    current: number,
    pageSize: number
}

export interface SpringPageable {
    page: number;
    size: number;
    sort?: string;
}

//AUTH
export interface AuthBodyModel { //TODO: same as LoginModel. Delete?
    username: string,
    password: string,
}

export type JWTToken = {
    id_token: string;
}

export type LoginModel = {
    username: string;
    password: string;
}

//CALL REGISTRY
export interface BasicUserDTO {
    id: number,
    email: string,
    name: string,
    lastname: string
}

export interface DocumentType {
    code: string;
    name: string;
}

export interface DocumentDto {
    id: number;
    documentType: string;
    mimeType: string
    name: string;
    emailSubject: string;
    emailBody: string;
    originalFileName: string;
    createdAt: Date;
    createdBy: BasicUserDTO;
    updatedAt: Date;
    updatedBy: BasicUserDTO;
}

export interface BasicDocumentDto {
    id: number;
    name: string;
    emailSubject: string;
    emailBody: string;
}

export interface CallerMetadata {
    fullName: string,
    phone: string,
    email: string
}

export interface CallRegistryDTO {
    id?: number,
    basicUserDTO?: BasicUserDTO,
    createdAt?: string,
    isDone: boolean,
    metadata: CallerMetadata,
    note: string,
}

export interface PersonActivityDTO {
    id: number,
    personDTO: BasicPersonDTO
    callRegistryDTO: CallRegistryProjectionDTO
    scadenza:string

}

export interface BasicPersonDTO {
    id: number,
    lastName: string,
    firstName: string,
    fiscalCode: string
}

export interface CallRegistryProjectionDTO {
    simulatorId: number,
    note: string,
    isDone: boolean,
    metadata: CallerMetadata
    createdAt: string,
    createdById: number,
    createdByUsername: string
}

export interface FileTsAuditDto {
    id: number;
    fileTsId: number;
    status: {
        id: number;
        code: string;
        description: string;
    };
    metadata: {
        [key: string]: any;
    };
    updatedBy: {
        id: number;
        nome: string;
        cognome: string;
    } | null;
    updatedAt: string;
}


export interface SimulatorPersonIdPair {
    simulatorId: number,
    personId: number,
}

export interface SuspendRequest {
    reason: string;
}

export interface UpdateSanctionRequest {
    fileTSIds: number[];
    value: number;
}

export const SUSPENSION_REASON_LABELS: Record<string, string> = {
    RATA_NON_PAGATA: "Rata non pagata",
    MANCATO_PAGAMENTO: "Mancato pagamento",
    ISTRUTTORIA: "Istruttoria",
    DECESSO: "Decesso",
    SCADUTA_ISTRUTTORIA: "Scaduta istruttoria",
    SCADUTA_DECESSO: "Scaduta decesso"
};

export const TYPE_LABELS: Record<string, string> = {
    DIFFIDA: "Diffida",
    VERBALE: "Verbale",
    REGOLARIZZAZIONE: "Regolarizzazione",
};

export interface ArchiveRequest {
    simulatorPersonIdPairs: SimulatorPersonIdPair[];
    fileTsIds: number[];
    reason: string
}

export interface Utente {
    id: number,
    email: string,
    nome: string,
    cognome: string,
    ruolo: Ruolo
}

export interface DocumentMetadata {
    uuid: string;
    originalName: string;
    contentType: string;
    size: number;
    uploadDate: string;
    documentTypeCode:string
    extension:string;
    userUploadDate:string
    signed?: boolean;
}

export interface ImportError {
    id: number,
    processed_file_id: number,
    row: number,
    error: string,
}

export enum TypeE {
    DIFFIDA = "DIFFIDA",
    VERBALE = "VERBALE"
}

export enum TemplateDocumentType {
    RICALCOLO_SEPARATO = "RICALCOLO_SEPARATO",
    RICALCOLO_RICETTE = "RICALCOLO_RICETTE",
    RICALCOLO_LR_NO_RATEPAGATE = "RICALCOLO_LR_NO_RATEPAGATE",
    RICALCOLO_LR_RATEPAGATE = "RICALCOLO_LR_RATEPAGATE",
    NOTA_ARCHIVIAZIONE = "NOTA_ARCHIVIAZIONE"
}

export enum DocumentTypeCode {
    ACCOGLIMENTO_RATE = "ACCOGLIMENTO_RATE",
    RATE_NON_PAGATE = "RATE_NON_PAGATE",
    RATE_NON_PAGATE_MONTE = "RATE_NON_PAGATE_MONTE",
}

export enum StatusCodeE {
    DA_LAVORARE = "DA_LAVORARE",
    IN_LAVORAZIONE = "IN_LAVORAZIONE",
    DA_FIRMARE = "DA_FIRMARE",
    NOTIFICA = "NOTIFICA",
    ATTESA_PAGAMENTO = "ATTESA_PAGAMENTO",
    SOSPESE = "SOSPESE",
    SCADUTE = "SCADUTE",
    RENDICONTATE = "RENDICONTATE",
    PAGATE = "PAGATE",
    TRASFERITE = "TRASFERITE",
    DA_TRASFERIRE = "DA_TRASFERIRE",
    ATTESA_FIRMA = "ATTESA_FIRMA",
    ATTESA_PAGOPA = "ATTESA_PAGOPA",
    RESIDUE = "RESIDUE",
    DA_RENDICONTARE = "DA_RENDICONTARE",
    ESCLUSO_DA_RICALCOLO = "ESCLUSO_DA_RICALCOLO",
    ARCHIVIATE = "ARCHIVIATE",
}

export enum AlertStatus {
    CREATO = "CREATO",
    SOSPESO = "SOSPESO",
    NOTIFICATO = "NOTIFICATO",
    ANNULLATO = "ANNULLATO"
}

export interface NonPaymentAlertSimpleDto {
    id: number;
    personId: number;
    fiscalCode: string;
    fullName: string;
    archiveProtocol: string;
    deadline: string;
    simulatorId:number
}

export const NOT_AGGREGATED_STATUSES:string[] = [StatusCodeE.DA_LAVORARE, StatusCodeE.RESIDUE];

export const stepIndexMap: Record<string, number> = {
    "Notifica": 0,
    "Attesa Pagamento": 1,
    "PAGATE": 2, //TODO: change capitalization in BE to be compliant to other cases
    "Sospese": 3,
    "Scadute": 4,
    "TRASFERITE": 5, //TODO: change capitalization in BE to be compliant to other cases
    "Archiviate": 6, //TODO: change capitalization in BE to be compliant to other cases
    "Da Rendicontare": 7,
    "Rendicontate": 8,
};

export const readableToEnumStatus: Record<string, StatusCodeE> = {
    "Attesa Pagamento": StatusCodeE.ATTESA_PAGAMENTO,
    "Notifica": StatusCodeE.NOTIFICA,
    "Sospese": StatusCodeE.SOSPESE,
    "Archiviate": StatusCodeE.ARCHIVIATE,
    "PAGATE": StatusCodeE.PAGATE, //TODO: change capitalization in BE to be compliant to other cases
    "TRASFERITE": StatusCodeE.TRASFERITE, //TODO: change capitalization in BE to be compliant to other cases
    "Rendicontate": StatusCodeE.RENDICONTATE,
    "Da Rendicontare": StatusCodeE.DA_RENDICONTARE,
};


export const ARCHIVE_REASON_LABELS: Record<string, string> = {
    DECEDUTO: "Deceduto",
    DECEDUTO_SENZA_EREDI: "Deceduto senza eredi",
    IRREPERIBILE: "Irreperibile",
    ISTRUTTORIA_ESITO_POSITIVO: "Istruttoria esito positivo",
    IMPORTO_ANTIECONOMICO: "Importo antieconomico",
};

export const PAID_REASON_LABELS: Record<string, string> = {
    ALL_INSTALLMENTS_COMPLETED: "Tutte le rate sono state pagate",
    UNIQUE_INSTALLMENT_PAID: "La rata unica è stata pagata"
};

export const ATTESA_PAGAMENTO_REASON_LABELS: Record<string, string> = {
    RATEIZZAZIONE: "Rateizzazione",
    CONFERMA_PAGAMENTO: "Conferma pagamento"
};

export function getArchiveReasonLabel(reason: string): string {
    return ARCHIVE_REASON_LABELS[reason] ?? reason;
}

export function getSuspensionReasonLabel(reason: string): string {
    return SUSPENSION_REASON_LABELS[reason] ?? reason;
}

export enum SquareTileTitle {
    SCRIVANIA = "Scrivania Da Lavoro",
    FASCICOLO = "Fascicolo",
    CRUSCOTTO = "Cruscotto",
    ATTIVITA = "Attività Registro Telefonate",
    AMMINISTRAZIONE = "Amministrazione"
}



export enum RoutingURL {
    HOME = "/",
    LOGIN = "/login",
    SCRIVANIA = "/ScrivaniaDaLavoro",
    CRUSCOTTO = "/Cruscotto/:status",
    DOSSIER = "/Fascicolo",
    SETTINGS = "/Amministrazione",
    USERDETAILS = "/Fascicolo/DettagliUtente/:id",
    USERDETAILSPRACTICES = "/Fascicolo/DettagliUtente/:id/:combinatorIdFromExt",
    PRACTICES = "/ScrivaniaDaLavoro/:id/:status",
    REPORT_CHIAMATE = "/Report/ReportChiamate",
    REPORT_RATE = "/Report/ReportRate",
    REPORT_INCASSI = "/Report/ReportIncassi",
    MODULES = "/Amministrazione/Moduli",
    VARIABLES = "/Amministrazione/VariabiliDiCalcolo",
    ACTIVITY = "/Attivita",
    AVVISO = "/AvvisoDiMancatoPagamento",
    REPORT = "/Report",
    USERS = "/Amministrazione/GestioneUtenti",
    PROFILE = "/Profilo",
}

export type HttpStatus = "CONTINUE" | "SWITCHING_PROTOCOLS" | "PROCESSING" | "CHECKPOINT" | "OK" | "CREATED" | "ACCEPTED" | "NON_AUTHORITATIVE_INFORMATION" | "NO_CONTENT" | "RESET_CONTENT" | "PARTIAL_CONTENT" | "MULTI_STATUS" | "ALREADY_REPORTED" | "IM_USED" | "MULTIPLE_CHOICES" | "MOVED_PERMANENTLY" | "FOUND" | "MOVED_TEMPORARILY" | "SEE_OTHER" | "NOT_MODIFIED" | "USE_PROXY" | "TEMPORARY_REDIRECT" | "PERMANENT_REDIRECT" | "BAD_REQUEST" | "UNAUTHORIZED" | "PAYMENT_REQUIRED" | "FORBIDDEN" | "NOT_FOUND" | "METHOD_NOT_ALLOWED" | "NOT_ACCEPTABLE" | "PROXY_AUTHENTICATION_REQUIRED" | "REQUEST_TIMEOUT" | "CONFLICT" | "GONE" | "LENGTH_REQUIRED" | "PRECONDITION_FAILED" | "PAYLOAD_TOO_LARGE" | "REQUEST_ENTITY_TOO_LARGE" | "URI_TOO_LONG" | "REQUEST_URI_TOO_LONG" | "UNSUPPORTED_MEDIA_TYPE" | "REQUESTED_RANGE_NOT_SATISFIABLE" | "EXPECTATION_FAILED" | "I_AM_A_TEAPOT" | "INSUFFICIENT_SPACE_ON_RESOURCE" | "METHOD_FAILURE" | "DESTINATION_LOCKED" | "UNPROCESSABLE_ENTITY" | "LOCKED" | "FAILED_DEPENDENCY" | "TOO_EARLY" | "UPGRADE_REQUIRED" | "PRECONDITION_REQUIRED" | "TOO_MANY_REQUESTS" | "REQUEST_HEADER_FIELDS_TOO_LARGE" | "UNAVAILABLE_FOR_LEGAL_REASONS" | "INTERNAL_SERVER_ERROR" | "NOT_IMPLEMENTED" | "BAD_GATEWAY" | "SERVICE_UNAVAILABLE" | "GATEWAY_TIMEOUT" | "HTTP_VERSION_NOT_SUPPORTED" | "VARIANT_ALSO_NEGOTIATES" | "INSUFFICIENT_STORAGE" | "LOOP_DETECTED" | "BANDWIDTH_LIMIT_EXCEEDED" | "NOT_EXTENDED" | "NETWORK_AUTHENTICATION_REQUIRED";

export type ErrorCode = "REQUEST_APPROVAL_EXCEPTION" | "REQUEST_SUSPENSION_EXCEPTION" | "ENTITY_NOT_FOUND" | "RUNTIME_ERROR" | "UNKNOWN_ERROR" | "ACCESS_DENIED" | "ASSIGNMENT_EXCEPTION";

export interface SendAttachment {
    key: string,
    title: string,
    description: string | null,
}

export interface SendError {
    code: string,
    description: string | null,
}

export type SendStatusType = "TO_BE_SENT"|"IN_VALIDATION" | "ACCEPTED" | "REFUSED" | "DELIVERING"| "DELIVERED"| "VIEWED"| "EFFECTIVE_DATE"| "PAID"| "UNREACHABLE"| "CANCELLED"| "ALTRO_MEZZO"| "RETURNED_TO_SENDER" | "-";

export const SendStatusLabel: Record<SendStatusType, string> = {
    "TO_BE_SENT":"Da inviare" ,
    "IN_VALIDATION":"In fase di validazione" ,
    "ACCEPTED":"Accettata",
    "REFUSED":"Rifiutata",
    "DELIVERING":"Invio in corso" ,
    "DELIVERED":"Consegnata" ,
    "VIEWED":"Avvenuto accesso",
    "EFFECTIVE_DATE":"Perfezionata per decorrenza termini",
    "PAID":"Pagata",
    "UNREACHABLE":"Irreperibile",
    "CANCELLED":"Annullata",
    "ALTRO_MEZZO": "Altro mezzo",
    "-": "-",
    "RETURNED_TO_SENDER": "Restituita al mittente"
};
export interface PhysicalAddress {
    address: string,
    zip: string,
    municipality: string,
    province: string,
    addressDetails: string,
}
export interface SendData {
    status: SendStatusType,
    iun: string | null,
    notificationRequestId: string,
    createdAt: string,
    updatedAt: string | null,
    attachments: SendAttachment[]
    errors: SendError[],
    notificationDate: string | null,
    registeredLetterCode: string | null,
    deliveryDetailCode: string | null,
    analogCost: number | null,
    notificationCost: number | null,
    serviceLevel: string | null,
    physicalAddress:PhysicalAddress;
}

export interface CallCountRow {
    userId: number;
    count: number;
    operatorName: string;
    userFiscalCode: string;
    userFirstName: string;
    userLastName: string;
    callDateTime: string;
    isDone: boolean;
}


